var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 11,
    fill: "#A259FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H12.3062C12.5522 12 12.6752 12 12.7742 12.0452C12.8614 12.0851 12.9353 12.1492 12.9871 12.2299C13.0459 12.3215 13.0633 12.4433 13.0981 12.6869L13.5714 16M13.5714 16L14.6233 23.7314C14.7568 24.7125 14.8235 25.2031 15.0581 25.5723C15.2648 25.8977 15.5611 26.1564 15.9114 26.3174C16.3089 26.5 16.8039 26.5 17.7941 26.5H26.352C27.2945 26.5 27.7658 26.5 28.151 26.3304C28.4905 26.1809 28.7818 25.9398 28.9923 25.6342C29.2309 25.2876 29.3191 24.8247 29.4955 23.8988L30.8191 16.9497C30.8812 16.6238 30.9122 16.4609 30.8672 16.3335C30.8278 16.2218 30.7499 16.1277 30.6475 16.068C30.5308 16 30.365 16 30.0332 16H13.5714ZM19 31C19 31.5523 18.5523 32 18 32C17.4477 32 17 31.5523 17 31C17 30.4477 17.4477 30 18 30C18.5523 30 19 30.4477 19 31ZM27 31C27 31.5523 26.5523 32 26 32C25.4477 32 25 31.5523 25 31C25 30.4477 25.4477 30 26 30C26.5523 30 27 30.4477 27 31Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.c161cbd8b7ea82aaf1bf66564fb5fdf6.svg";
export { ForwardRef as ReactComponent };